import { render } from "./CrudTools.vue?vue&type=template&id=17465766&scoped=true"
import script from "./CrudTools.vue?vue&type=script&lang=js"
export * from "./CrudTools.vue?vue&type=script&lang=js"

import "./CrudTools.vue?vue&type=style&index=0&id=17465766&lang=css"
import "./CrudTools.vue?vue&type=style&index=1&id=17465766&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17465766"]])

export default __exports__